export default{
  'solid': 'Sólido',
  'regular': 'Regular',
  'light': 'Light',
  'brands': 'Brands',
  'duotone': 'Duotone',
  options: [
    { value: 'solid', text: 'Sólido' },
    { value: 'regular', text: 'Regular' },
    { value: 'light', text: 'Light' },
    { value: 'brands', text: 'Brands' },
    { value: 'duotone', text: 'Duotone' },
  ],
}
